(function() {
  // POOM · Script del carrito
  //  1) Refresca contador y carrito lateral cuando otras secciones cambian el carrito.
  //  2) Regalos de rutina: aplica a la vez los códigos REGALO-... de todas las rutinas
  //     que haya en el carrito (cada regalo lleva la propiedad oculta _codigo).
  //  3) Página /cart: + / − / Eliminar funcionan con control propio.
  //  4) Carrito lateral: con 1 unidad, el "−" elimina el producto (también en móvil).
  const _fetch = window.fetch.bind(window);
  const onCartPage = location.pathname.indexOf('/cart') === 0;
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  const ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function refreshThemeCart() {
    if (onCartPage) return;
    ['cart:refresh','cart:updated','cart:build','cart:rerender'].forEach(function(name){
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    if (window.jQuery) {
      try { jQuery(document).trigger('cart.requestComplete'); } catch(e){}
    }
  }

  // ---- 2) Códigos de regalo de rutina ----
  function syncRegalos() {
    return _fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var want = [];
        cart.items.forEach(function(it){
          var c = it.properties && it.properties._codigo;
          if (c && want.indexOf(c.toUpperCase()) === -1) want.push(c.toUpperCase());
        });
        var current = (cart.discount_codes || []).map(function(d){ return String(d.code).toUpperCase(); });
        var others = current.filter(function(c){ return c.indexOf('REGALO-') !== 0; });
        var next = others.concat(want);
        var same = next.length === current.length && next.every(function(c){ return current.indexOf(c) > -1; });
        if (same) return false;
        return _fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: next.join(',') })
        }).then(function(){ return true; });
      })
      .catch(function(){ return false; });
  }

  // Evita recargas en bucle si Shopify no aceptara el cambio de códigos
  function safeReload() {
    try {
      var last = parseInt(sessionStorage.getItem('poomRegReload') || '0', 10);
      if (Date.now() - last < 8000) return;
      sessionStorage.setItem('poomRegReload', String(Date.now()));
    } catch(e) {}
    location.reload();
  }

    // ---- Regalos del aceite: 2 Recellix + 4D + Fase Activadora por cada aceite ----
  var OIL_GIFTS = [
       { id: '64739014771065', per: 1 }
  ];
  function ensureOilGifts() {
    return _fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var oil = 0, other = {}, tagged = {};
      cart.items.forEach(function(it){
        var vid = String(it.variant_id);
       if (vid === '55605586657657' && !(it.properties && it.properties._regalo === 'Regalo promo Snow Gold')) oil += it.quantity;
        if (it.properties && it.properties._regalo === 'aceite') { (tagged[vid] = tagged[vid] || []).push(it); }
        else { other[vid] = (other[vid] || 0) + it.quantity; }
      });
      var add = [], updates = {};
      OIL_GIFTS.forEach(function(g){
        var target = Math.max(0, g.per * oil - (other[g.id] || 0));
        var lines = tagged[g.id] || [];
        var have = lines.reduce(function(s, l){ return s + l.quantity; }, 0);
        if (have < target) add.push({ id: Number(g.id), quantity: target - have, properties: { _regalo: 'aceite' } });
        if (have > target) {
          var keep = target;
          lines.forEach(function(l){ var q = Math.min(l.quantity, keep); keep -= q; if (q !== l.quantity) updates[l.key] = q; });
        }
      });
      var step = Promise.resolve(false);
      if (Object.keys(updates).length) {
        step = _fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function(){ return true; });
      }
      if (add.length) {
        step = step.then(function(){
          return _fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: add }) }).then(function(){ return true; });
        });
      }
      return step;
    }).catch(function(){ return false; });
  }

  var syncing = false;
  function afterCartChange() {
    if (syncing) return;
    syncing = true;
    ensureOilGifts().then(function(a){
      return syncRegalos().then(function(b){ return a || b; });
    }).then(function(changed){
      syncing = false;
      if (changed && onCartPage) { safeReload(); return; }
      refreshThemeCart();
    });
  }


  // ---- Aceite con regalos: al añadir Radiance Oil Soap se añade el pack con regalos ----
  var OIL_VARIANT = '55605586657657';
  var OIL_PACK_HANDLE = 'radiance-oil-soap-con-regalos-pdrn';
  var OIL_PACK_VARIANT = null;             // se rellena si el pack está disponible
  var PACK_REGALOS = {
    'radiance-oil-soap-con-regalos-pdrn': ['2 × Tratamiento Recellix Dr. Tufet (PDRN)|4D Dermacode · tratamiento individual|Power y Firming · formato viaje', '47 €']
  };
  _fetch('/products/' + OIL_PACK_HANDLE + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
    if (!p || !p.available) return;
    var v = (p.variants || []).filter(function(x){ return x.available; })[0];
      // Desactivado: el aceite ya no se cambia por el pack. Los regalos se añaden sueltos (ensureOilGifts).
  }).catch(function(){});
  function swapOil(body) {
    if (!OIL_PACK_VARIANT || body == null) return body;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function(val, key){
          if ((key === 'id' || /\[id\]$/.test(key)) && String(val) === OIL_VARIANT) body.set(key, OIL_PACK_VARIANT);
        });
        return body;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var s2 = body.toString().replace(new RegExp('(^|&)(id|items%5B\\d+%5D%5Bid%5D)=' + OIL_VARIANT + '(?=&|$)', 'g'), '$1$2=' + OIL_PACK_VARIANT);
        return new URLSearchParams(s2);
      }
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{') {
          var j = JSON.parse(t);
          if (j.items) j.items.forEach(function(it){ if (String(it.id) === OIL_VARIANT) it.id = Number(OIL_PACK_VARIANT); });
          if (j.id != null && String(j.id) === OIL_VARIANT) j.id = Number(OIL_PACK_VARIANT);
          return JSON.stringify(j);
        }
        return body.replace(new RegExp('(^|&)(id|items%5B\\d+%5D%5Bid%5D|items\\[\\d+\\]\\[id\\])=' + OIL_VARIANT + '(?=&|$)', 'g'), '$1$2=' + OIL_PACK_VARIANT);
      }
    } catch(e) {}
    return body;
  }
  function swapOilUrl(url) {
    if (!OIL_PACK_VARIANT || typeof url !== 'string') return url;
    return url.replace(new RegExp('([?&]id=)' + OIL_VARIANT + '(?=&|$)'), '$1' + OIL_PACK_VARIANT);
  }

  // ---- 1) Detectar cambios del carrito hechos por el tema u otras secciones ----
  window.fetch = function() {
    var a0 = arguments[0];
    var url = (a0 && a0.url) ? a0.url : a0;
    var args = Array.prototype.slice.call(arguments);
    if (typeof url === 'string' && ADD_RE.test(url)) {
      if (typeof args[0] === 'string') args[0] = swapOilUrl(args[0]);
      if (args[1] && args[1].body != null) { args[1] = Object.assign({}, args[1]); args[1].body = swapOil(args[1].body); }
    }
    var p = _fetch.apply(null, args);
    if (typeof url === 'string' && CART_RE.test(url)) {
      p.then(function(r){
        if (!r || !r.ok) return;
        setTimeout(afterCartChange, 150);
        if (ADD_RE.test(url)) {
          r.clone().json().then(onThemeAdd).catch(function(){});
        }
      }).catch(function(){});
    }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (this._poomAdd) body = swapOil(body);
    return _send.call(this, body);
  };
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && ADD_RE.test(url)) { this._poomAdd = true; url = swapOilUrl(url); arguments[1] = url; }
    if (typeof url === 'string' && CART_RE.test(url)) {
      var isAdd = ADD_RE.test(url);
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(afterCartChange, 150);
          if (isAdd) { try { onThemeAdd(JSON.parse(this.responseText)); } catch(e){} }
        }
      });
    }
    return _open.apply(this, arguments);
  };

  // ---- 3) Página /cart: control propio de + / − / Eliminar ----
  if (onCartPage) {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.t4s-cartPage__form [data-quantity-selector], .t4s-cartPage__form [data-cart-remove], .t4s-cartPage__form .poom-cart-remove');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var row = btn.closest('[data-cart-item]');
      if (!row || row.dataset.poomBusy) return;
      var input = row.querySelector('input[data-quantity-value]');
      var key = btn.dataset.id || (input && input.dataset.id);
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      var newQty = 0;
      if (btn.hasAttribute('data-increase-qty')) newQty = qty + 1;
      else if (btn.hasAttribute('data-decrease-qty')) newQty = Math.max(qty - 1, 0);
      row.dataset.poomBusy = '1';
      row.style.opacity = '.5';
      _fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function(){ return syncRegalos(); })
        .then(function(){ location.reload(); })
        .catch(function(){ location.reload(); });
    }, true);
  }

  // ---- 4) Carrito lateral: con 1 unidad, el "−" elimina el producto ----
  var lastMinus = 0;
  function onMiniMinus(e) {
    var btn = e.target.closest && e.target.closest('.t4s-mini_cart__item [data-decrease-qty]');
    if (!btn) return;
    var item = btn.closest('.t4s-mini_cart__item');
    var input = item.querySelector('input[data-quantity-value]');
    var qty = input ? (parseInt(input.value, 10) || 0) : 0;
    if (qty > 1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var now = Date.now();
    if (now - lastMinus < 700) return;
    lastMinus = now;
    var key = (input && input.dataset.id) || '';
    var removeLink = item.querySelector('[data-cart-remove]');
    item.style.opacity = '.5';
    if (removeLink) removeLink.click();
    setTimeout(function() {
      if (!key) return;
      _fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var still = cart.items.some(function(it){ return it.key === key; });
        if (!still) return;
        return _fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(){ location.reload(); });
      }).catch(function(){});
    }, 1000);
  }
  document.addEventListener('touchend', onMiniMinus, { capture: true, passive: false });
  document.addEventListener('click', onMiniMinus, true);

  // ---- 5) Aviso "Añadido a tu carrito" al añadir una rutina ----
  // Intercepta los formularios de rutina (los que llevan el snippet rutina-regalos),
  // añade por AJAX, aplica los códigos de regalo y muestra solo lo recién añadido.
  function eur(cents) {
    try { return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
    catch(e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }

  function poomPopupCss() {
    if (document.getElementById('poom-added-css')) return;
    var css = document.createElement('style');
    css.id = 'poom-added-css';
    css.textContent =
      '.poom-added{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(11,27,43,.55);opacity:0;transition:opacity .2s}' +
      '.poom-added.is-on{opacity:1}' +
      '.poom-added__box{background:#fff;width:min(520px,calc(100% - 32px));max-height:calc(100vh - 48px);display:flex;flex-direction:column;border-top:3px solid #C2A46A;box-shadow:0 20px 60px rgba(11,27,43,.35);font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;color:#16222D}' +
      '.poom-added__head{display:flex;align-items:center;justify-content:space-between;padding:18px 22px 14px;border-bottom:1px solid #DCDDD8}' +
      '.poom-added__t{font-family:Georgia,serif;font-size:22px;color:#16324A;margin:0;display:flex;align-items:center;gap:10px}' +
      '.poom-added__t i{width:24px;height:24px;border-radius:50%;background:#16324A;color:#fff;display:inline-flex;align-items:center;justify-content:center;font-style:normal;font-size:13px}' +
      '.poom-added__x{background:none;border:0;font-size:26px;line-height:1;color:#5E5A57;cursor:pointer;padding:4px}' +
      '.poom-added__list{overflow:auto;padding:6px 22px}' +
      '.poom-added__it{display:flex;gap:14px;align-items:center;padding:12px 0;border-bottom:1px solid #F4F5F6}' +
      '.poom-added__it:last-child{border-bottom:0}' +
      '.poom-added__img{width:58px;height:58px;flex-shrink:0;background:#F4F5F6;object-fit:cover}' +
      '.poom-added__info{flex:1;min-width:0}' +
      '.poom-added__n{font-size:14px;line-height:1.3;color:#16222D}' +
      '.poom-added__q{font-size:12px;color:#5E5A57;margin-top:2px}' +
      '.poom-added__tag{display:inline-block;margin-top:4px;font-size:10px;letter-spacing:.14em;font-weight:700;text-transform:uppercase;color:#0F2233;background:#C2A46A;padding:2px 6px}' +
      '.poom-added__p{font-size:14px;font-weight:600;white-space:nowrap;text-align:right}' +
      '.poom-added__p del{display:block;font-weight:400;font-size:12px;color:#8a8784}' +
      '.poom-added__p .is-free{color:#86693A}' +
      '.poom-added__foot{padding:14px 22px 20px;border-top:1px solid #DCDDD8}' +
      '.poom-added__sum{display:flex;justify-content:space-between;font-size:15px;margin-bottom:14px}' +
      '.poom-added__sum b{font-family:Georgia,serif;font-size:20px;color:#16324A;font-weight:400}' +
      '.poom-added__btns{display:flex;gap:10px}' +
      '.poom-added__btns a,.poom-added__btns button{flex:1;display:flex;align-items:center;justify-content:center;min-height:48px;font-size:12px;font-weight:700;letter-spacing:.13em;text-transform:uppercase;text-decoration:none;cursor:pointer;font-family:inherit}' +
      '.poom-added__go{background:#16324A;color:#fff;border:1px solid #16324A}' +
      '.poom-added__go:hover{background:#0F2233}' +
      '.poom-added__keep{background:#fff;color:#16324A;border:1px solid #DCDDD8}' +
      '.poom-added__keep:hover{border-color:#16324A}' +
      '.poom-added__gift{margin:6px 0 10px;background:#FBF7EE;border:1px solid #C2A46A;border-left:3px solid #C2A46A;padding:10px 12px}' +
      '.poom-added__gt{margin:0 0 6px;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#16324A}' +
      '.poom-added__gt span{font-weight:400;text-transform:none;letter-spacing:0;color:#86693A}' +
      '.poom-added__gift ul{list-style:none;margin:0;padding:0}' +
      '.poom-added__gift li{display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:13px;padding:4px 0;border-top:1px dashed rgba(194,164,106,.5)}' +
      '.poom-added__gift li:first-child{border-top:0}' +
      '.poom-added__gift b{font-size:10px;letter-spacing:.14em;text-transform:uppercase;background:#C2A46A;color:#0F2233;padding:2px 6px}' +
      '@media(max-width:640px){.poom-added{align-items:flex-end}.poom-added__box{width:100%;max-height:85vh;padding-bottom:env(safe-area-inset-bottom,0px)}.poom-added__btns{flex-direction:column-reverse}}';
    document.head.appendChild(css);
  }

  function showAdded(lines, regalos, valor) {
    poomPopupCss();
    var old = document.querySelector('.poom-added'); if (old) old.remove();
    var total = 0, html = '';
    lines.forEach(function(it){
      var isGift = it.properties && it.properties.Regalo;
      var orig = (typeof it.original_line_price === 'number') ? it.original_line_price : it.line_price;
      var fin = (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
      if (isGift) fin = 0; // los regalos de la rutina siempre van a 0 €
      total += fin;
      var img = it.image ? String(it.image).replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      html += '<div class="poom-added__it">' +
        (img ? '<img class="poom-added__img" src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '<span class="poom-added__img"></span>') +
        '<div class="poom-added__info"><div class="poom-added__n">' + esc(it.product_title || it.title) + '</div>' +
        '<div class="poom-added__q">Cantidad: ' + it.quantity + '</div>' +
        (isGift ? '<span class="poom-added__tag">Regalo</span>' : '') +
        '</div>' +
        '<div class="poom-added__p">' + (fin < orig ? '<del>' + eur(orig) + '</del>' : '') +
        '<span class="' + (fin === 0 ? 'is-free' : '') + '">' + eur(fin) + '</span></div></div>';
    });
    if (regalos) {
      html += '<div class="poom-added__gift"><p class="poom-added__gt">🎁 Tus regalos' + (valor ? ' <span>· valorados en ' + esc(valor) + '</span>' : '') + '</p><ul>' +
        regalos.split('|').map(function(r){ return '<li><span>' + esc(r) + '</span><b>Gratis</b></li>'; }).join('') + '</ul></div>';
    }
    var wrap = document.createElement('div');
    wrap.className = 'poom-added';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Añadido a tu carrito');
    wrap.innerHTML =
      '<div class="poom-added__box">' +
        '<div class="poom-added__head"><p class="poom-added__t"><i>✓</i>Añadido a tu carrito</p><button type="button" class="poom-added__x" aria-label="Cerrar">×</button></div>' +
        '<div class="poom-added__list">' + html + '</div>' +
        '<div class="poom-added__foot"><div class="poom-added__sum"><span>Total de lo añadido</span><b>' + eur(total) + '</b></div>' +
        '<div class="poom-added__btns"><button type="button" class="poom-added__keep">Seguir comprando</button><a class="poom-added__go" href="/cart">Ver carrito</a></div></div>' +
      '</div>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function(){ wrap.classList.add('is-on'); });
    function close() { wrap.classList.remove('is-on'); setTimeout(function(){ wrap.remove(); }, 200); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    wrap.addEventListener('click', function(e){ if (e.target === wrap) close(); });
    wrap.querySelector('.poom-added__x').addEventListener('click', close);
    wrap.querySelector('.poom-added__keep').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    wrap.querySelector('.poom-added__go').focus();
  }


  // ---- 5b) Aviso también al añadir cualquier producto (fichas, portada, etc.) ----
  function closeThemeDrawer() {
    // Si el tema abrió el carrito lateral, lo cerramos: el aviso lo sustituye
    var tries = 0;
    var t = setInterval(function(){
      tries++;
      var drawer = document.querySelector('#t4s-mini_cart');
      var open = drawer && (drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is--opend') || drawer.classList.contains('is-open'));
      if (open) {
        var btn = drawer.querySelector('[data-drawer-close], .t4s-drawer__close, button[aria-label*="lose"], button[aria-label*="errar"]');
        if (btn) btn.click();
        clearInterval(t);
      }
      if (tries > 10) clearInterval(t);
    }, 120);
  }
  function onThemeAdd(data) {
    if (!data) return;
    var items = data.items || (data.key ? [data] : []);
    if (!items.length) return;
    // Precios con descuentos ya aplicados, si Shopify los devuelve en el carrito
    _fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var keys = items.map(function(i){ return i.key; });
      var lines = cart.items.filter(function(it){ return keys.indexOf(it.key) > -1; });
      // Mostrar la cantidad recién añadida, no la acumulada en el carrito
      var shown = (lines.length ? lines : items).map(function(l){
        var a = items.filter(function(i){ return i.key === l.key; })[0];
        if (!a || !l.quantity) return l;
        var unitFinal = (l.final_line_price || l.line_price) / l.quantity;
        var unitOrig = (l.original_line_price || l.line_price) / l.quantity;
        var c = Object.assign({}, l);
        c.quantity = a.quantity;
        c.final_line_price = Math.round(unitFinal * a.quantity);
        c.original_line_price = Math.round(unitOrig * a.quantity);
        return c;
      });
      var reg = null;
      shown.forEach(function(l){ if (!reg && PACK_REGALOS[l.handle]) reg = PACK_REGALOS[l.handle]; });
      showAdded(shown, reg ? reg[0] : null, reg ? reg[1] : null);
      closeThemeDrawer();
    }).catch(function(){ showAdded(items); closeThemeDrawer(); });
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action="/cart/add"]')) return;
    var packInput = form.querySelector('input[data-poom-pack]');
    if (!packInput || !packInput.value) return;   // sin producto-rutina: el formulario funciona como siempre
    e.preventDefault();
    if (form.dataset.poomBusy) return;
    form.dataset.poomBusy = '1';
    var variantId = packInput.value;
    var btn = form.querySelector('[type="submit"]');
    var btnHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>AÑADIENDO…</span>'; }
    function restore() { delete form.dataset.poomBusy; if (btn) { btn.disabled = false; btn.innerHTML = btnHtml; } }
    _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function(added){
        var keys = (added.items || [added]).map(function(i){ return i.key; });
        return _fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var lines = cart.items.filter(function(it){ return keys.indexOf(it.key) > -1; });
          restore();
          refreshThemeCart();
          showAdded(lines.length ? lines : (added.items || []), packInput.getAttribute('data-regalos'), packInput.getAttribute('data-valor'));
        });
      })
      .catch(function(){
        // Plan B: añadir el producto-rutina por URL e ir al carrito
        restore();
        location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1';
      });
  }, true);

  // ---- 6) Pestaña "Política de cookies" (Pandectes) ----
  // En móvil se oculta la pestaña flotante para que no tape botones.
  // Cualquier enlace que termine en #cookies (p. ej. "Configurar cookies" en el pie)
  // abre el mismo panel de preferencias.
  function findCookieTab() {
    var found = null;
    document.querySelectorAll('button, a, div, span').forEach(function(el){
      if (found) return;
      if ((el.textContent || '').trim() !== 'Política de cookies') return;
      var n = el;
      for (var i = 0; i < 5 && n && n !== document.body; i++) {
        var pos = getComputedStyle(n).position;
        if (pos === 'fixed' || pos === 'sticky') { found = { btn: el, box: n }; return; }
        n = n.parentElement;
      }
    });
    return found;
  }
  function hideCookieTabOnMobile() {
    if (!window.matchMedia('(max-width: 767px)').matches) return false;
    var t = findCookieTab();
    if (!t) return false;
    t.box.style.setProperty('display', 'none', 'important');
    return true;
  }
  (function watchCookieTab(){
    var tries = 0;
    var timer = setInterval(function(){
      tries++;
      if (hideCookieTabOnMobile() && tries > 6) { clearInterval(timer); }
      if (tries > 40) clearInterval(timer);   // deja de buscar a los 20 s
    }, 500);
  })();
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href$="#cookies"]');
    if (!a) return;
    var t = findCookieTab();
    if (!t) return;            // si Pandectes aún no cargó, el enlace no hace nada raro
    e.preventDefault();
    t.btn.click();
  });

  // ---- 7) Formularios clásicos (p. ej. la ficha del aceite): cambiar el aceite por el pack ----
  document.addEventListener('submit', function(e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || String(idInput.value) !== OIL_VARIANT || !OIL_PACK_VARIANT) return;
    e.preventDefault();
    e.stopImmediatePropagation();          // que el tema no lo añada también
    if (form.dataset.poomBusy) return;
    form.dataset.poomBusy = '1';
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var btn = form.querySelector('[type="submit"]');
    var btnHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo…'; }
    function restore() { delete form.dataset.poomBusy; if (btn) { btn.disabled = false; btn.innerHTML = btnHtml; } }
    _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(OIL_PACK_VARIANT), quantity: qty }] })
    })
      .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function(added){ restore(); refreshThemeCart(); onThemeAdd(added); })
      .catch(function(){
        // Plan B: añadir el pack por URL e ir al carrito
        restore();
        location.href = '/cart/add?id=' + OIL_PACK_VARIANT + '&quantity=' + qty;
      });
  }, true);

  // ---- 8) Cualquier otro formulario "Añadir al carrito": añadir sin salir de la página + aviso ----
  document.addEventListener('submit', function(e) {
    if (e.defaultPrevented) return;                       // rutinas y aceite ya gestionados
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-poom-native')) return;    // escape por si algún formulario debe ir al carrito
    if (!form.querySelector('[name="id"], [name^="items["]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();                         // que el tema no lo añada por duplicado
    if (form.dataset.poomBusy) return;
    form.dataset.poomBusy = '1';
    var btn = form.querySelector('[type="submit"]');
    var btnHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo…'; }
    function restore() { delete form.dataset.poomBusy; if (btn) { btn.disabled = false; btn.innerHTML = btnHtml; } }
    var fd = swapOil(new FormData(form));
    fd.delete('return_to');
    _fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      })
      .then(function(added){ restore(); refreshThemeCart(); onThemeAdd(added); })
      .catch(function(err){
        restore();
        // Sin stock u otro aviso de Shopify: mostrarlo; si es otro fallo, envío normal
        if (err && (err.description || err.message)) { alert(err.description || err.message); return; }
        form.setAttribute('data-poom-native', '1');
        form.submit();
      });
  }, true);

  // ---- Al cargar cualquier página: ajustar códigos de regalo ----
    function init() {
    ensureOilGifts().then(function(a){
      return syncRegalos().then(function(b){ return a || b; });
    }).then(function(changed){
      if (!changed) return;
      if (onCartPage) { safeReload(); return; }
      refreshThemeCart();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();